import { forwardRef } from 'react'

import Box from 'components/atomic/atoms/box'

import DotsSvg from './dots.svg'
import DotsLightSvg from './dotsLight.svg'

export const Dots = forwardRef<HTMLImageElement>((props, ref) => {
  return (
    <>
      <Box
        {...props}
        as="img"
        ref={ref}
        data-hide-on-theme="light"
        src={DotsSvg.src}
        aria-hidden
        alt=""
        css={{
          ...(props as any).css,
          position: 'absolute',
          pointerEvents: 'none',

          maxWidth: 'none',
          width: 'calc(var(--scale) * 184)',
          top: 'calc(var(--scale) * var(--dots-y, 0))',
          left: 'calc(var(--scale) * var(--dots-left, initial))',
          right: 'calc(var(--scale) * var(--dots-right, initial))',

          rotate: 'var(--dots-rotate, 0deg)',
        }}
      />
      <Box
        {...props}
        as="img"
        ref={ref}
        data-hide-on-theme="dark"
        src={DotsLightSvg.src}
        aria-hidden
        alt=""
        css={{
          ...(props as any).css,
          position: 'absolute',
          pointerEvents: 'none',

          maxWidth: 'none',
          width: 'calc(var(--scale) * 184)',
          top: 'calc(var(--scale) * var(--dots-y, 0))',
          left: 'calc(var(--scale) * var(--dots-left, initial))',
          right: 'calc(var(--scale) * var(--dots-right, initial))',

          rotate: 'var(--dots-rotate, 0deg)',
        }}
      />
    </>
  )
})

Dots.displayName = 'Dots'

export function DotsCenter() {
  return <Box as={Dots} css={{ '--dots-y': -325, '--dots-rotate': '90deg' }} />
}

export function DotsLeft() {
  return (
    <Box
      as={Dots}
      css={{
        '--dots-left': -87,

        '@md': {
          '--dots-left': -110,
        },
      }}
    />
  )
}

export function DotsRight() {
  return (
    <Box
      as={Dots}
      css={{
        transform: 'scaleX(-1)',
        '--dots-right': -87,

        '@md': {
          '--dots-right': -110,
        },
      }}
    />
  )
}
